import React from "react";

function TitansHero() {
  return (
    <>
    
      <div className='container-fluid'>
          <div className="row">
            <div className="col ps-0 pe-0">
              <div className="d-none d-md-block">
                <img src="./s3/10_player_montage.jpg"
                  className="w-100" 
                  alt=""
                />
              </div>
              <div className="d-block d-md-none">
                <img src="./s3/10_player_montage_mobile.jpg"
                  className="w-100" 
                  alt="ADS Sports Complex and ADS Titans are
                  proud to welcome Coach Brandon Branch as the 
                  new ADS Titans Head Coach"
                />
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default TitansHero;
